// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__37S9J","legacyBtn":"MutateMid_legacyBtn__3T-_1"};